import React from 'react';
import { SchoolSchoolyearContext } from './SchoolSchoolyearContext';

interface Props {
  schoolyearId?: string;
  schoolId?: string;
  disabled?: boolean;
  children: React.ReactNode;
}

export function FakeSchoolSchoolyearProvider(
  props: Props & { schoolyear: any; school: any },
) {
  const { schoolyear, school, ...rest } = props;
  return (
    <SchoolSchoolyearContext.Provider
      value={{ schoolyear, school }}
      {...rest}
    />
  );
}
